import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_PROXY_LOGIN, SUPERSET_PROXY_LOGIN_ERROR, SUPERSET_PROXY_LOGIN_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetProxyLogin({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const endpoint = payload?.endpoint || `${programManagementURL}/api/v1/superset/login`;
    const method = payload?.method || 'POST';

    const response = yield call(apiCall, {
      url: endpoint,
      method,
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_PROXY_LOGIN_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_PROXY_LOGIN_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_PROXY_LOGIN_ERROR, payload: error });
  }
}

export function* watchSupersetProxyLogin() {
  yield takeEvery(SUPERSET_PROXY_LOGIN, supersetProxyLogin);
}

function* getSupersetProxyLoginSaga() {
  yield all([fork(watchSupersetProxyLogin)]);
}

export default getSupersetProxyLoginSaga;
